import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

function IPhoneMockup({ src, alt }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  // Fade out and drift upward as user scrolls past
  const opacity = useTransform(scrollYProgress, [0, 0.4, 0.85, 1], [0, 1, 1, 0]);
  const y = useTransform(scrollYProgress, [0, 0.35, 0.85, 1], [80, 0, 0, -40]);
  const scale = useTransform(scrollYProgress, [0, 0.35], [0.88, 1]);

  return (
    <div
      ref={ref}
      style={{ perspective: "1400px" }}
      className="flex justify-center items-center w-full"
    >
      <motion.div style={{ opacity, y, scale }}>
        <div
          style={{
            transform: "rotateY(-16deg) rotateX(5deg) rotateZ(0.5deg)",
            transformStyle: "preserve-3d",
            width: "320px",
            height: "655px",
            borderRadius: "56px",
            background: "linear-gradient(160deg, #2e2e2e 0%, #1c1c1c 40%, #101010 100%)",
            boxShadow: `
              inset 0 0 0 1.5px rgba(255,255,255,0.13),
              inset 0 0 0 3.5px #161616,
              40px 60px 120px rgba(0,0,0,0.6),
              -4px -4px 28px rgba(255,255,255,0.04),
              10px 20px 50px rgba(0,180,200,0.1)
            `,
            padding: "12px",
            position: "relative",
          }}
        >
          {/* Silent switch */}
          <div style={{
            position: "absolute", left: "-5px", top: "88px",
            width: "4px", height: "26px",
            background: "linear-gradient(to right, #151515, #3a3a3a)",
            borderRadius: "2px 0 0 2px",
          }} />
          {/* Volume up */}
          <div style={{
            position: "absolute", left: "-5px", top: "128px",
            width: "4px", height: "44px",
            background: "linear-gradient(to right, #151515, #3a3a3a)",
            borderRadius: "2px 0 0 2px",
            boxShadow: "-1px 0 4px rgba(0,0,0,0.5)",
          }} />
          {/* Volume down */}
          <div style={{
            position: "absolute", left: "-5px", top: "184px",
            width: "4px", height: "44px",
            background: "linear-gradient(to right, #151515, #3a3a3a)",
            borderRadius: "2px 0 0 2px",
            boxShadow: "-1px 0 4px rgba(0,0,0,0.5)",
          }} />
          {/* Power button */}
          <div style={{
            position: "absolute", right: "-5px", top: "170px",
            width: "4px", height: "68px",
            background: "linear-gradient(to left, #151515, #3a3a3a)",
            borderRadius: "0 2px 2px 0",
            boxShadow: "1px 0 4px rgba(0,0,0,0.5)",
          }} />

          {/* Screen */}
          <div style={{
            width: "100%", height: "100%",
            borderRadius: "46px",
            overflow: "hidden",
            background: "#000",
            position: "relative",
          }}>
            <img
              src={src}
              alt={alt}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />

            {/* Screen glare */}
            <div style={{
              position: "absolute", inset: 0,
              background: "linear-gradient(135deg, rgba(255,255,255,0.07) 0%, transparent 45%)",
              borderRadius: "46px",
              pointerEvents: "none",
            }} />
          </div>

          {/* Bezel top shine */}
          <div style={{
            position: "absolute", top: 0, left: "22%", right: "22%",
            height: "1px",
            background: "linear-gradient(to right, transparent, rgba(255,255,255,0.22), transparent)",
          }} />
        </div>
      </motion.div>
    </div>
  );
}

export default IPhoneMockup;
